export enum NumberFormat {
  PERCENTAGE = "percentage",
  KILOWATT = "kilowatt",
  CURRENCY = "currency",
  INTEGER = "integer",
  UNIT = "unit",
}

export enum DateFormat {
  LONG = "long",
  LONG_WITH_TIME = "longWithTime",
  TWELVE_HOUR = "twelveHour",
  TWENTY_FOUR_HOUR = "twentyFourHour",
  TIME = "time",
}
